
import {computed, defineComponent, PropType, reactive, toRefs} from 'vue'
import { CtSupplier, CtSupplierCatalogue} from '@/models/interfaces/content-type'
import useContentModule from '@/pages/composables/useContentModule'
import {useStore} from 'vuex'
import EditableBlock from '@/components/EditableBlock.vue'
import EditableBlockInput from '@/components/EditableBlockInput.vue'
import Clipable from '@/components/Clipable.vue'
import {useQuasar} from 'quasar'
import Directr from '@/services/directr'

import CryptoJS from 'crypto-js'

export default defineComponent({
  name: 'SupplierCatalogueSettings',
  components: { EditableBlockInput, EditableBlock, Clipable },
  props: {
    supplierCatalogue: {
      type: Object as PropType<CtSupplierCatalogue>,
      required: true
    }
  },
  emits: ['update:supplier-catalogue', 'update:supplier'],
  setup (props, {emit}) {
    const $q = useQuasar()
    const $store = useStore()

    const { items: suppliers, fetch } = useContentModule<CtSupplier>('Supplier', $store)
    void fetch([{ select: ['name'] }])
    const supplierOptions = computed(() => suppliers.value?.filter(c => c.name || c.id).map((c) => ({ label: c.name || c.id, value: c.sys.id })))

    const CHANNEL_API_KEY_PRE_ID = 'OZNST'
    const channelToken = computed(() => `${CHANNEL_API_KEY_PRE_ID}-${CryptoJS.SHA256(String(Math.round(Math.random())+Date.now()))}`)

    const state = reactive({
      showTokenModal: false,
    })

    function showChannelTokenModal () {
      state.showTokenModal = true
    }

    function clearChannelToken () {
      state.showTokenModal = false

      $q.dialog({
        title: 'Remove Channel API Key?',
        message: 'This will remove the current API key for this Channel. This action cannot be undone',
        cancel: true,
      }).onCancel(() => false).onDismiss(() => false).onOk(() => {
        emit('update:supplier-catalogue', props.supplierCatalogue.supplier, { token: { access_token: null } })
      })
    }

    function regenerateChannelToken () {
      state.showTokenModal = false
      $q.dialog({
        title: 'Regenerate Channel API Key?',
        message: 'This will remove the current API key for this Channel and generate a new one. This action cannot be undone',
        cancel: true,
      }).onCancel(() => false).onDismiss(() => false).onOk(() => {
        emit('update:supplier-catalogue', props.supplierCatalogue.supplier, { token: { access_token: null } })
        state.showTokenModal = true
      })
    }

    function saveChannelToken (access_token) {
      state.showTokenModal = false
      emit('update:supplier-catalogue', props.supplierCatalogue.supplier, { token: { access_token } })

      // const supplier = await $directr.get(ContentType.Supplier, isUUID(props.supplierCatalogue.supplier) ? props.supplierCatalogue.supplier : props.supplierCatalogue.supplier.sys.id )
      // console.log(supplier)
    }

    return {
      ...toRefs(state),
      channelToken,
      supplierOptions,
      showChannelTokenModal,
      saveChannelToken,
      clearChannelToken,
      regenerateChannelToken,
      clipped: () => {
        $q.notify({ message: 'Copied to clipboard', position: 'top', classes: 'custom-notify' })
      },
    }
  },

})
